const QUICK_PROMPTS = [
    "How does the referral process work?",
    "What ages do you serve?",
    "Tell me about your therapeutic approach.",
    "What does daily life look like?",
];

export default function QuickPrompts({ onPick }) {
    return (
        <div className="px-4 pb-2 bg-[#F7F5F0]">
            <p className="text-[11px] uppercase tracking-wider text-[#6F6B63] mb-2 px-1">
                Try asking
            </p>
            <div className="flex flex-wrap gap-1.5">
                {QUICK_PROMPTS.map((q) => (
                    <button
                        key={q}
                        onClick={() => onPick(q)}
                        className="text-left text-[12.5px] bg-white border border-[#E5DFD3] hover:border-[#0E2A47] hover:text-[#0E2A47] rounded-full px-3 py-1.5 transition-colors"
                        data-testid={`chatbot-quick-${q.slice(0, 12)}`}
                    >
                        {q}
                    </button>
                ))}
            </div>
        </div>
    );
}
